import type * as Types from '../../types';

import client from "apollo/client";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetModulesQueryVariables = Types.Exact<{
  order?: Types.InputMaybe<Array<Types.ModuleSortInput> | Types.ModuleSortInput>;
}>;


export type GetModulesQuery = { __typename?: 'Query', modules?: { __typename?: 'ModuleCollectionSegment', items?: Array<{ __typename?: 'Module', id: string, moduleName: string, lastStartedModuleInstance?: { __typename?: 'ModuleInstance', entryAssemblyVersion?: string | null, runtimeVersion: string, healthStatus: Types.ModuleHealthStatus } | null }> | null } | null };


export type ExecGetModulesOptions = Omit<
  Apollo.QueryOptions<GetModulesQueryVariables, GetModulesQuery>,
  "query"
  >;
export const execGetModulesQuery = (options: ExecGetModulesOptions) =>
  client.query<GetModulesQuery, GetModulesQueryVariables>({
    ...options,
    query: GetModulesDocument,
  });
    

export const GetModulesDocument = gql`
    query getModules($order: [ModuleSortInput!]) {
  modules(order: $order) {
    items {
      id
      moduleName
      lastStartedModuleInstance {
        entryAssemblyVersion
        runtimeVersion
        healthStatus
      }
    }
  }
}
    `;

/**
 * __useGetModulesQuery__
 *
 * To run a query within a React component, call `useGetModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModulesQuery({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetModulesQuery(baseOptions?: Apollo.QueryHookOptions<GetModulesQuery, GetModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModulesQuery, GetModulesQueryVariables>(GetModulesDocument, options);
      }
export function useGetModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModulesQuery, GetModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModulesQuery, GetModulesQueryVariables>(GetModulesDocument, options);
        }
export type GetModulesQueryHookResult = ReturnType<typeof useGetModulesQuery>;
export type GetModulesLazyQueryHookResult = ReturnType<typeof useGetModulesLazyQuery>;
export type GetModulesQueryResult = Apollo.QueryResult<GetModulesQuery, GetModulesQueryVariables>;
  export type PartialResultType<T> = Types.PartialResultType<T>;
          export type ResultType<T> = Types.ResultType<T>;
          export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
          export type NonMaybe<T> = Types.NonMaybe<T>;
          export type Maybe<T> = Types.Maybe<T>;